import React, { useState } from 'react'
import axios from 'axios'
import OrganizationForm from './OrganizationForm'
import { t } from '../../i18n'
import SectionTitle from '../shared/sectionTitle'

const UpdateOrganizationForm: React.FC<{
  organization: {
    id: number;
    name: string;
    code: string;
    address: string,
    order_providers: []
  } }> = ({ organization: initialOrganization }) => {

  const initialOrderProviders = () => {
    return initialOrganization.order_providers?.map((provider: any) => {
      return {
        id: provider.id,
        provider_type: provider.provider_type,
        credentials: provider.credentials,
        connected: provider.connected,
        destroyable: provider.destroyable,
        robo_api_key_set: provider.robo_api_key_set,
        _destroy: false,
      }
    }) || []
  }

  const initialOrganizationState = () => {
    return {
      id: initialOrganization.id,
      name: initialOrganization.name,
      code: initialOrganization.code,
      address: initialOrganization.address,
      order_providers_attributes: initialOrderProviders()
    }
  }

  const [organization, setOrganization] = useState(initialOrganizationState)
  const [saveSuccessful, setSaveSuccessful] = useState<boolean | null>(null)
  const [saveText, setSaveText] = useState('')

  const orderProvidersWithoutConnectedAttribute = (data) => {
    return data.order_providers_attributes.map((provider) => {
      const { connected, ...rest } = provider
      return rest
    })
  }

  const handleSubmit = (data, onFinished) => {
    axios
      .put(`/admin/organizations/${organization.id}`, {
        ...data,
        order_providers_attributes: orderProvidersWithoutConnectedAttribute(data)
      })
      .then((resp) => {
        setSaveSuccessful(true)
        setSaveText(t('save_successful', { scope: 'organizations' }))
        onFinished(true, null)
        setOrganization(resp.data)
      })
      .catch((error) => {
        setSaveSuccessful(false)
        setSaveText(t('save_failed', { scope: 'organizations' }))
        onFinished(false, error.response.data)
      })
  }

  const renderSaveMessage = () => {
    if (saveText) {
      return (
        <div
          className={`alert alert-${saveSuccessful ? 'success' : 'danger'}`}
          role="alert"
        >
          {saveText}
        </div>
      )
    }
  }

  return (
    <>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <SectionTitle rows={['Edit', t('organizations.organization')]} />
      </div>
      <div className="card card-robis">
        <div className="row">
          <div className="col-sm-12">
            {renderSaveMessage()}
            <OrganizationForm
              organization={organization}
              onSubmitForm={handleSubmit}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default UpdateOrganizationForm
